/* ============================================================
   Reign Total Body Fuel — landing (slug 'reign').
   Cargado por layout/landing.liquid (case 'reign').
   Bloques: galería del buy box · selección de bundle (.nx-tier) ·
   selector de sabor · slider de ingredientes · modal de reseñas ·
   disparo del modal Releasit COD.
   Patrón Releasit (per-unit + quantity): cada bundle = 1 variante con precio
   POR UNIDAD; mandamos quantity = N (paquetes) para que el pedido lleve las
   unidades reales y el total sea el del bundle. Releasit lee
   input[name="quantity"] del DOM al disparar. NO usar _rsiV2.setState como
   primer path — el click nativo del botón Releasit SÍ re-lee productData.
   Ver memory/project_bundles_as_variants.
   ============================================================ */

/* ---------- Galería: thumbnail cambia imagen principal ---------- */
function setMain(src, el) {
  var main = document.getElementById('mainImg');
  if (main) main.src = src;
  document.querySelectorAll('.nx-thumb').forEach(function (t) { t.classList.remove('active'); });
  if (el) el.classList.add('active');
}

/* ---------- Slider de ingredientes ---------- */
function ingScroll(d) {
  var t = document.getElementById('ingTrack');
  if (t) t.scrollBy({ left: d * 340, behavior: 'smooth' });
}

/* ============================================================
   Releasit COD trigger + selección de bundle
   ============================================================ */
var RELEASIT_SELECTORS = [
  '#rsi_buy_now_button',
  '.rsi_buy_now_button',
  '._rsi-buy-now-button',
  '._rsi-buy-now-button-app-block-hook button',
  '._rsi-buy-now-button-app-block-hook a',
  '.rsi-btn-skel'
];

function reignFindReleasitButton() {
  for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
    var el = document.querySelector(RELEASIT_SELECTORS[i]);
    if (el) return el;
  }
  return null;
}

var reignSelectedVariantId = null;
var reignSelectedQty = 1;

// Cada bundle = una variante con precio POR UNIDAD; mandamos la cantidad real
// (1/2/3 paquetes) para que el pedido llegue con las unidades exactas (Dropi
// envía la cantidad) y el total quede en el precio del bundle. Releasit lee el
// input[name="quantity"] del DOM al disparar COD.
function reignSetVariantOnAllForms(variantId, qty) {
  if (!variantId) return;
  var q = parseInt(qty, 10);
  if (!q || q < 1) q = 1;
  document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
    input.value = String(q);
    input.setAttribute('value', String(q));
  });
  if (window.productData) { window.productData.quantity = q; }
  if (window.productData && Array.isArray(window.productData.variants)) {
    var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
    if (v) {
      window.productData.selected_or_first_available_variant = v;
      window.productData.selected_variant = v;
      try {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
        document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
      } catch (e) {}
    }
  }
}

function reignBundleQty(el) {
  var q = parseInt(el.getAttribute('data-bundle-qty'), 10);
  if (!q) { var idx = parseInt(el.getAttribute('data-bundle-index'), 10); q = isNaN(idx) ? 1 : idx + 1; }
  return q || 1;
}

// Selección de tier (combo). Llamado por onclick="pickTier(this)" en cada .nx-tier.
function pickTier(el) {
  document.querySelectorAll('.nx-tier').forEach(function (t) { t.classList.remove('active'); });
  el.classList.add('active');
  var p = el.getAttribute('data-price');
  var cur = document.getElementById('curPrice');
  if (p && cur) cur.textContent = p;
  var id = el.getAttribute('data-bundle-variant-id');
  if (id) {
    reignSelectedVariantId = id;
    reignSelectedQty = reignBundleQty(el);
    reignSetVariantOnAllForms(id, reignSelectedQty);
  }
}

function reignTriggerCOD(btn) {
  var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || reignSelectedVariantId;
  var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || reignSelectedQty;
  if (variantId) reignSetVariantOnAllForms(variantId, qty);
  setTimeout(function () {
    var releasitBtn = reignFindReleasitButton();
    if (releasitBtn) { releasitBtn.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = reignFindReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }, 50);
}

/* ---------- Init: sabor, modal reseñas, bundle activo ---------- */
(function () {
  // Selector de sabor (decorativo)
  document.querySelectorAll('.nx-flavor button').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelectorAll('.nx-flavor button').forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
    });
  });

  // Estrellas del modal de reseña
  window.rvVal = 5;
  document.querySelectorAll('#rvStars span').forEach(function (s) {
    s.addEventListener('click', function () {
      window.rvVal = +s.dataset.v;
      document.querySelectorAll('#rvStars span').forEach(function (x) { x.classList.toggle('on', +x.dataset.v <= window.rvVal); });
    });
    s.classList.add('on');
  });

  // Bundle activo al cargar (el marcado .active o el primero)
  var active = document.querySelector('.nx-tier.active[data-bundle-variant-id]') || document.querySelector('.nx-tier[data-bundle-variant-id]');
  if (active) {
    reignSelectedVariantId = active.getAttribute('data-bundle-variant-id');
    reignSelectedQty = reignBundleQty(active);
    reignSetVariantOnAllForms(reignSelectedVariantId, reignSelectedQty);
  }
})();

function submitReview() {
  var n = document.getElementById('rvName').value || 'Anónimo';
  var t = document.getElementById('rvText').value || '';
  var rvVal = window.rvVal || 5;
  var d = document.createElement('div');
  d.className = 'nx-review';
  d.innerHTML = '<div class="nx-rev-card"><div class="nx-rev-who"><div class="nx-avatar">' + n[0].toUpperCase() + '</div><div><b>' + n + '</b><div class="nx-verified">✓ Compra Verificada</div></div></div><div class="nx-rec-mini">👍 Recomienda este producto</div></div><div class="body"><span class="meta">ahora</span><span class="nx-stars">' + '★'.repeat(rvVal) + '</span><div class="title">Reseña</div><div class="txt">' + t + '</div></div>';
  document.getElementById('revList').prepend(d);
  document.getElementById('revModal').classList.remove('open');
}
